const RenderUserAgent: React.FC = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return (
        <ul>
            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
            {/* @ts-ignore */}
            {Object.entries(window.userAgent || { Not: 'found' }).map(([a, b], index) => (
                <li key={index}>
                    <b>{JSON.stringify(a)}:</b>
                    {JSON.stringify(b)}
                </li>
            ))}
        </ul>
    );
};

export default RenderUserAgent;
